// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/styles.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StatusSelect-module_status_label_jYqUd {
}

.StatusSelect-module_status_label_small_disTi {
}

.StatusSelect-module_status_label_small_disTi span {
  font-size: 12px;
}

.StatusSelect-module_disabled_gYvyD,
.StatusSelect-module_inactive__dVXC {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/client/components/Generic/BOSSelect/StatusSelect.module.css"],"names":[],"mappings":"AAAA;AAEA;;AAEA;AAEA;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;AACtB","sourcesContent":[".status_label {\n  composes: status_tag from 'Styles/styles.module.css';\n}\n\n.status_label_small {\n  composes: status_label;\n}\n\n.status_label_small span {\n  font-size: 12px;\n}\n\n.disabled,\n.inactive {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status_label": `StatusSelect-module_status_label_jYqUd ${___CSS_LOADER_ICSS_IMPORT_0___.locals["status_tag"]}`,
	"status_label_small": `StatusSelect-module_status_label_small_disTi StatusSelect-module_status_label_jYqUd ${___CSS_LOADER_ICSS_IMPORT_0___.locals["status_tag"]}`,
	"disabled": `StatusSelect-module_disabled_gYvyD`,
	"inactive": `StatusSelect-module_inactive__dVXC`
};
export default ___CSS_LOADER_EXPORT___;
